import { render, staticRenderFns } from "./ApplyToTeam.vue?vue&type=template&id=05638165&"
import script from "./ApplyToTeam.vue?vue&type=script&lang=js&"
export * from "./ApplyToTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports